import { dayNames, monthNames } from "utilities/dateFormat";

export const availableAchievementActivityCondition = [
  "always_available",
  "is_after",
  "is_before",
  "is_day_of_week",
  "is_day_of_month",
  "is_month_of_year",
  "is_between",
  "is_not_between",
  "is_time_between",
] as const;

export type AvailableAchievementActivityConditionType =
  (typeof availableAchievementActivityCondition)[number];

export type AchievementActivity =
  | {
      data: string;
      operator: "is_after" | "is_before";
    }
  | {
      data: { from: string; to: string };
      operator: "is_between" | "is_not_between" | "is_time_between";
    }
  | {
      data: (typeof dayNames)[number][];
      operator: "is_day_of_week";
    }
  | {
      data: (typeof monthNames)[number][];
      operator: "is_day_of_month";
    }
  | {
      data: (typeof monthNames)[number][];
      operator: "is_month_of_year";
    }
  | {
      data: number;
      operator: "is_nth_day_of_the_month";
    }
  | { operator: "always_available" }
  | { data: null; operator: "" };
